import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const TimelineBar = ({
  data,
  currentTime,
  handleMouseMove,
  handleMouseLeave,
  hoverTime,
  plusPosition,
  openModal,
  ACTIVITIES
}) => {
  const currentPercent = (currentTime / 24) * 100;

  return (
    <Box
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      sx={{
        position: 'relative',
        height: 24,
        bgcolor: '#f9fafb',
        borderRadius: 1,
        border: '1px solid #e0e0e0',
        background: '#fff',
        cursor: 'pointer',
        userSelect: 'none',
      }}
      onClick={openModal}
    >
      {data.map((slot, i) => {
        if (slot.start > currentTime) return null;
        const left = `${(slot.start / 24) * 100}%`;
        const rightEdge = Math.min(slot.end, currentTime);
        const width = `${((rightEdge - slot.start) / 24) * 100}%`;
        return (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left,
              width,
              bgcolor: ACTIVITIES[slot.type]?.color || '#ccc',
            }}
          />
        );
      })}

      {/* Future Background Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: `${currentPercent}%`,
          right: 0,
          backgroundColor: '#859FC4',
          opacity: 0.6,
          zIndex: 1,
          marginLeft: '2px',
        }}
      />

      {/* Current Time Line */}
      <Box
        sx={{
          position: 'absolute',
          top: '-4px',
          bottom: '-4px',
          left: `${currentPercent}%`,
          width: '4px',
          backgroundColor: '#859FC4',
          zIndex: 2,
          borderRadius: '15px',
          marginLeft: '2px',
        }}
      />

      {/* Plus Icon on Hover */}
      {plusPosition !== null && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            openModal();
          }}
          sx={{
            position: 'absolute',
            top: '50%',
            left: plusPosition,
            transform: 'translate(-50%, -50%)',
            bgcolor: '#fff',
            border: '1px solid #0076FE',
            width: '22px',
            height: '22px',
            color: '#0076FE',
            boxShadow: '0 0 0 2px #fff',
            '&:hover': {
              bgcolor: '#fff',
            },
            zIndex: 3,
            pointerEvents: 'auto',
          }}
          size="small"
        >
          <AddIcon fontSize="small" />
        </IconButton>
      )}

      {/* Hover Time Label */}
      {hoverTime !== null && (
        <Typography
          sx={{
            position: 'absolute',
            top: -20,
            left: plusPosition,
            transform: 'translateX(-50%)',
            fontSize: 10,
            bgcolor: 'background.paper',
            px: 0.5,
            borderRadius: 0.5,
            pointerEvents: 'none',
            userSelect: 'none',
            color: '#0076FE',
            whiteSpace: 'nowrap',
            boxShadow: 1,
            zIndex: 3,
          }}
        >
          {hoverTime.toFixed(1)}h Add Time
        </Typography>
      )}
    </Box>
  );
};

export default TimelineBar;